import { ICONS } from 'Utils/icons';

/**
 * type,
 * postedDate,
 * eventDate,
 * eventTime,
 * registrationEndDate,
 * registrationCloseInfo,
 * isRegistration,
 * title,
 * description,
 * icon,
 * docGroupId,
*/
export const NEWS_EVENT_CARD_DATA = [
  {
    type: "EVENT",
    postedDate: "POSTED MAY 28, 2026",
    eventDate: "June 25, 2026",
    eventTime: "1:00 PM - 2:00 PM ET",
    registrationEndDate: "06-25-2026",
    registrationCloseInfo: "June 25th",
    isRegistration: true,
    title: "Quarterly Call",
    description: "A quarterly virtual convening hosted by AHRQ's PSO Division for federally listed Patient Safety Organizations. Sessions include program updates, new resource announcements, and patient safety initiatives relevant to PSO operations.",
    icon: null,
    docGroupId: null,
  },
  {
    type: "ARTICLE",
    postedDate: "POSTED JANUARY 9, 2026",
    eventDate: null,
    eventTime: null,
    registrationEndDate: null,
    registrationCloseInfo: null,
    isRegistration: false,
    title: "Considerations for Using Cloud Services and AI within a PSO",
    description: "A quarterly virtual convening hosted by AHRQ's PSO Division for federally listed Patient Safety Organizations. Sessions include program updates, new resource announcements, and patient safety initiatives relevant to PSO operations.",
    icon: ICONS.downloadoutline,
    docGroupId: 2903,
  },
  {
    type: "EVENT",
    postedDate: "POSTED MAY 22, 2026",
    eventDate: "July 10, 2025",
    eventTime: "11:00 AM - 11:50 AM ET",
    registrationEndDate: null,
    registrationCloseInfo: null,
    isRegistration: false,
    title: "FHIR Workgroup Meeting",
    description: "Members of the FHIR Workgroup will be meeting to discuss API Developments, Pilot Updates and other FHIR related topics.",
    icon: null,
    docGroupId: null,
  }
]